import React, { useState, useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import HttpService from "../services/HttpService";

// Fetch available MCC codes
async function fetchMccCodes(inputValue, employerId) {
  // If no employer is selected, return empty data
  if (!employerId) return { data: [] };

  const response = await HttpService.getAxiosClient().get(
    window.API_URL + `/mcc/all?search=${inputValue}&idEmployer=${employerId}`
  );
  return response;
}

const MccListSelector = ({ 
  formik 
}) => {
  // For MCC codes input
  const [inputValue, setInputValue] = useState("");

  const { data: mccCodesData, isLoading: isLoadingMccCodes } = useQuery(
    ["mccCodes", formik.values.companiesList?.idEmployer],
    () => fetchMccCodes(inputValue, formik.values.companiesList?.idEmployer),
    {
      enabled: !!formik.values.companiesList?.idEmployer,
    }
  );

  const debouncedSetInputValue = useMemo(() => {
    let timerId;
    return (value) => {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        setInputValue(value);
      }, 400);
    };
  }, []);

  return (
    <Autocomplete
      fullWidth
      multiple
      id="mccList"
      name="mccList"
      options={!isLoadingMccCodes ? (Array.isArray(mccCodesData?.data) ? mccCodesData?.data : []) : []}
      getOptionLabel={(option) => 
        `${option.code} - ${option.description}`
      }
      filterSelectedOptions
      value={formik.values.mccList}
      onChange={(event, selectedOptions) => {
        formik.setFieldValue("mccList", selectedOptions);
      }}
      disabled={!formik.values.companiesList?.idEmployer}
      renderInput={(params) => (
        <TextField
          {...params}
          error={formik.touched.mccList && Boolean(formik.errors.mccList)}
          helperText={
            (formik.touched.mccList && formik.errors.mccList) ||
            (!formik.values.companiesList?.idEmployer ? "Select a company first" : "")
          }
          label="MCC Codes"
          placeholder={formik.values.companiesList?.idEmployer ? "Type to search..." : "Select a company first"}
        />
      )}
    />
  );
};

export default MccListSelector;